module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('nav', {
    staticClass: "primaryNav"
  }, [_c('ul', {
    staticClass: "pages"
  }, _vm._l((_vm.primaryNav), function(link) {
    return _c('li', {
      class: [{
        active: _vm.isActive(link)
      }, _vm.toClass(link.label.en)]
    }, [_c('router-link', {
      attrs: {
        "to": _vm.to(link)
      }
    }, [_vm._v(_vm._s(_vm.renderText(link.label)))])])
  })), _c('ul', {
    staticClass: "langages"
  }, [_c('li', {
    staticClass: "ja",
    class: {
      active: !_vm.isEnglish
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.toJa
    }
  }, [_vm._v("JA")])]), _c('li', {
    staticClass: "en",
    class: {
      active: _vm.isEnglish
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.toEn
    }
  }, [_vm._v("EN")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e5e752ce!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/primaryNav.vue
// module id = 110
// module chunks = 1